import { usePhoneInput, defaultCountries } from "react-international-phone";
import "react-international-phone/style.css";
import SearchableCountrySelector from "./SearchableCountrySelector";
import "./PhoneInput.css";

const PREFERRED_COUNTRIES = ["in", "ae", "us", "gb"];

/**
 * Reusable international phone input for all SAC forms.
 * Uses libphonenumber-js (via react-international-phone) for formatting and validation.
 */
function PhoneInput({
  id,
  name = "phone",
  value,
  onChange,
  onBlur,
  error = false,
  className = "",
  placeholder = "Phone number",
  defaultCountry = "in",
  required = false,
  "aria-invalid": ariaInvalid,
  "aria-describedby": ariaDescribedBy,
}) {
  const {
    country,
    inputValue,
    inputRef,
    setCountry,
    handlePhoneValueChange,
  } = usePhoneInput({
    defaultCountry,
    value: value || "",
    countries: defaultCountries,
    preferredCountries: PREFERRED_COUNTRIES,
    forceDialCode: true,
    disableDialCodePrefill: false,
    onChange: (data) => {
      onChange?.(data.phone || "");
    },
  });

  return (
    <div
      className={`sac-phone-input ${error ? "sac-phone-input--error" : ""} ${className}`.trim()}
    >
      <SearchableCountrySelector
        countries={defaultCountries}
        preferredCountries={PREFERRED_COUNTRIES}
        selectedCountry={country?.iso2}
        onSelect={(selected) => {
          setCountry(selected.iso2, { focusOnInput: true });
        }}
      />
      <input
        ref={inputRef}
        id={id}
        name={name}
        type="tel"
        inputMode="tel"
        autoComplete="tel"
        value={inputValue}
        onChange={handlePhoneValueChange}
        onBlur={onBlur}
        placeholder={placeholder}
        required={required}
        aria-invalid={ariaInvalid ?? error}
        aria-describedby={ariaDescribedBy}
        className="sac-phone-input__field"
      />
    </div>
  );
}

export default PhoneInput;
